import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import Section from '../components/Section';
import { articles, SOURCES } from '../data/articles';

function formatDate(dateStr) {
  if (!dateStr || dateStr.length === 0) return '—';
  if (dateStr.length <= 4) return dateStr;
  const d = new Date(dateStr);
  return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' });
}

export default function Articles() {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredArticles = useMemo(() => {
    if (!searchQuery.trim()) return articles;
    const q = searchQuery.trim().toLowerCase();
    return articles.filter((a) => a.title.toLowerCase().includes(q));
  }, [searchQuery]);

  const displayList = filteredArticles.length > 0 ? filteredArticles : articles;

  return (
    <Section id="articles" title="Articles &amp; writing">
      <div className="articles-search-wrap" style={{ marginBottom: '1.5rem' }}>
        <input
          type="search"
          placeholder="Search articles…"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="articles-search"
          aria-label="Search articles"
        />
      </div>

      <div className="articles-graph-embed">
        <iframe
          src="/articles-graph/index.html"
          title="Article Knowledge Graph"
          className="articles-graph-frame"
          sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation"
        />
        <p className="articles-graph-caption">drag · scroll to zoom · click node to open article</p>
      </div>

      <motion.div
        className="articles-list-wrap"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        {filteredArticles.length === 0 ? (
          <p className="articles-no-results">No articles match your search or filters.</p>
        ) : (
          <>
            <div className="articles-source-block">
              <h3 className="articles-source-title">
                <a href={SOURCES.linkedin.url} target="_blank" rel="noopener noreferrer">
                  Hacking Simplified (LinkedIn)
                </a>
              </h3>
              <p className="articles-source-desc">Beginner-friendly security &amp; CTF guides. Published weekly.</p>
              <ul className="articles-ul">
                {displayList.filter((a) => a.source === 'linkedin').map((a) => (
                  <li key={a.id}>
                    <a href={a.url} target="_blank" rel="noopener noreferrer" className="articles-link">
                      {a.title}
                    </a>
                    <span className="articles-date">{formatDate(a.date)}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="articles-source-block">
              <h3 className="articles-source-title">
                <a href={SOURCES.hexmos.url} target="_blank" rel="noopener noreferrer">
                  Hexmos Journal
                </a>
              </h3>
              <p className="articles-source-desc">Philosophy × Engineering blog by Hexmos.</p>
              <ul className="articles-ul">
                {displayList.filter((a) => a.source === 'hexmos').map((a) => (
                  <li key={a.id}>
                    <a href={a.url} target="_blank" rel="noopener noreferrer" className="articles-link">
                      {a.title}
                    </a>
                    <span className="articles-date">{formatDate(a.date)}</span>
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </motion.div>
    </Section>
  );
}
